export default __webpack_public_path__ + "static/media/Lip_9_M.0d8324e0.svg";